module.exports = __webpack_public_path__ + "static/media/happy_place.e009db0c.ogg";